import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { buildApiUrl } from '../config';

const CoinDataContext = createContext();

export const CoinDataProvider = ({ children }) => {
  const [coinData, setCoinData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { isAuthenticated } = useAuth();


  const fetchCoinData = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetch(buildApiUrl('/coin/usdtidr'), {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      setCoinData(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // For development: fetch data regardless of auth status
    fetchCoinData();
    
    // Refresh data every 30 seconds
    const interval = setInterval(() => {
      fetchCoinData();
    }, 30000);
    
    return () => {
      clearInterval(interval);
    };
  }, []); // Empty dependency array - runs once on mount

  const value = {
    coinData,
    loading,
    error,
    refetch: fetchCoinData
  };

  return (
    <CoinDataContext.Provider value={value}>
      {children}
    </CoinDataContext.Provider>
  );
};

export const useCoinData = () => {
  const context = useContext(CoinDataContext);
  if (!context) {
    throw new Error('useCoinData must be used within a CoinDataProvider');
  }
  return context;
};
